import { useState, useEffect } from "react";
import { useLanguage } from "./LanguageContext";

export default function CompleteProfile() {
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(null);
  const [err, setErr] = useState("");
  const { t, language } = useLanguage();


  useEffect(() => {
    document.title = t("titles.complete");
  }, [language]);


  useEffect(() => {
    try {
      const p = JSON.parse(localStorage.getItem("pending_oauth") || "null");
      setPending(p);
      if (!p) setErr("Session expired. Please try Facebook login again.");
    } catch {
      setErr("Session expired. Please try Facebook login again.");
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const res = await fetch("/api/complete_profile.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (data.ok) {
        localStorage.removeItem("pending_oauth");
        localStorage.setItem("user", JSON.stringify(data.user));
        window.location.replace("/");
      } else {
        setErr(data.error || "Error");
      }
    } catch {
      setErr("Network error");
    }
  };

  if (err) return <div style={{padding:20}}>{err}</div>;

  return (
    <form onSubmit={submit} style={{padding:20, maxWidth:420}}>
      <h2>Finish signup</h2>
      <p>Please enter your email to complete your account.</p>
      <input
        type="email"
        required
        value={email}
        onChange={e=>setEmail(e.target.value)}
        placeholder="you@example.com"
        style={{width:'100%', padding:10, margin:'10px 0'}}
      />
      <button type="submit">Continue</button>
    </form>
  );
}
